module.exports = __webpack_public_path__ + "img/gs2.2ac999d3.png";